import { DiagnosticFunnel } from '../../../components/tools/DiagnosticFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('entreprises', 'diagnostic-cee')!;

export default function EntreprisesDiagnosticCeePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/entreprises"
        backLabel="Espace entreprises"
        duration="60 sec"
      >
        <DiagnosticFunnel lockedAudience="entreprises" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace entreprises', url: 'https://solutionecofrance.fr/entreprises' },
          { name: 'Diagnostic CEE', url: 'https://solutionecofrance.fr/entreprises/diagnostic-cee' },
        ]}
      />
    </>
  );
}
